import React from 'react';
import ProductHero from '../components/product/ProductHero';
import ProductFeatures from '../components/product/ProductFeatures';
import ProductFAQ from '../components/product/ProductFAQ';
import ProductCTA from '../components/product/ProductCTA';

const ProductDetail = () => {
 const handlePurchase = (planId) => {
 // Handle purchase logic
 console.log('Purchase plan:', planId);
 // You can add your purchase logic here
 };

 return (
 <div className="route-surface marketing-page min-h-screen bg-cream-100">
 <ProductHero onPurchase={handlePurchase} />
 <ProductFeatures />
 <ProductFAQ />
 <ProductCTA onPurchase={handlePurchase} />
 </div>
 );
};

export default ProductDetail;